<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <b-container v-if="student" id="scrollToOnLoad">
      <section class="section--saved_selection" id="scrollToOnLoad">
        <h2 class="text-center">{{ student.first_name }} {{ student.last_name }}
          <span class="text--shadow-center">{{ student.first_name }} {{ student.last_name }}</span>
        </h2>
        <p class="text-center text--small">The list of whole student's experiments</p>
      </section>
      <section class="experiments">
       <div v-for="(experiment, i) in experimentsList" :key="i">
          <list-of-experiments :experiment="experiment" :previewMode="true"></list-of-experiments>
        </div>
        <h3 v-if="!experimentsList.length">
         Student {{ student.first_name }} don't have any experimental results
        </h3>
      </section>
    </b-container>
    <section-support></section-support>
  </main>
</template>

<script>
import teacher from '@/api/v1/teacher';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import ListOfExperiments from '@/components/ListOfExperiments';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
    ListOfExperiments,
  },
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      student: null,
      experimentsList: [],
    };
  },
  methods: {
    getStudentDetails() {
      const succ = (response) => {
        this.student = response.data.student;
        this.experimentsList = response.data.experiments
          .filter(experiment => experiment.has_results);
      };
      teacher.studentExperiments(this.$route.params.studentId, succ);
    },
  },
  created() {
    this.getStudentDetails();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';
.section {
  &--saved_selection {
    padding: 130px 0 100px;
  }
}
.experiments {
  padding: 0 0 100px,
}
</style>



// WEBPACK FOOTER //
// src/views/Game/StudentsResultList.vue